import { Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { Notification, NotificationPage } from '../models/notification.model';

const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: 'n-01',
    type: 'SESSION_REMINDER',
    title: 'Session starts in 30 minutes!',
    message: 'System Design Masterclass is starting soon. Join now to get a good seat!',
    actionUrl: '/student/sessions/s-java-live-01/join',
    createdAt: new Date().toISOString(),
    read: false,
  },
  {
    id: 'n-02',
    type: 'NEW_LIVE_SESSION',
    title: 'New live session announced!',
    message: 'Microservices Architecture Patterns has been scheduled for Full Stack Java.',
    actionUrl: '/student/dashboard',
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    read: false,
  },
  {
    id: 'n-03',
    type: 'ENROLLMENT_CONFIRMED',
    title: 'Enrollment confirmed!',
    message: 'You have successfully enrolled in Java Fundamentals & OOP demo session.',
    actionUrl: '/student/dashboard',
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    read: false,
  },
  {
    id: 'n-04',
    type: 'DEMO_FOLLOWUP',
    title: 'How was the demo? 🎉',
    message: 'You attended your first demo! Subscribe now and get ₹500 off this week.',
    actionUrl: '/courses/c-java-01',
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    read: true,
  },
  {
    id: 'n-05',
    type: 'SUBSCRIPTION_CREATED',
    title: 'Welcome to Full Stack Java! 🚀',
    message: 'Your subscription is now active. All live sessions are unlocked.',
    actionUrl: '/student/dashboard',
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    read: true,
  },
];

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private notifications = [...MOCK_NOTIFICATIONS];
  readonly unreadCount = signal(MOCK_NOTIFICATIONS.filter(n => !n.read).length);

  getNotifications(filter?: 'all' | 'unread'): Observable<NotificationPage> {
    const content = filter === 'unread'
      ? this.notifications.filter(n => !n.read)
      : [...this.notifications];

    return of({
      content,
      totalElements: content.length,
      unreadCount: this.notifications.filter(n => !n.read).length,
    }).pipe(delay(300));
  }

  markAsRead(id: string): Observable<Notification> {
    const idx = this.notifications.findIndex(n => n.id === id);
    if (idx !== -1) {
      this.notifications[idx] = { ...this.notifications[idx], read: true };
      this.unreadCount.set(this.notifications.filter(n => !n.read).length);
    }
    return of(this.notifications[idx]).pipe(delay(100));
  }

  markAllAsRead(): Observable<void> {
    this.notifications = this.notifications.map(n => ({ ...n, read: true }));
    this.unreadCount.set(0);
    return of(void 0).pipe(delay(200));
  }
}
